<hr style="margin-top: 0px; margin-bottom: 0px;">

<p-confirmDialog key="cd" #cd>
  <ng-template #footer>
    <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
    <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
    <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
  </ng-template>
</p-confirmDialog>

<div *ngIf="awaitUsers && awaitUserGroups" class="col-sm-12">
  <p-table #userTable [columns]="userCols" [value]="userInfos" sortField="user">
    <ng-template let-columns pTemplate="header">
      <tr>
        <th *ngFor="let col of columns"  [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
          {{col.header}}
        </th>
      </tr>
    </ng-template>
    <ng-template let-columns="columns" let-rowData pTemplate="body">
      <tr style="height: 40px;">
        <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
          <div *ngIf="rowData.isGraphUser == undefined" style="color: purple">
            {{rowData.userName}} 
          </div>
          <div *ngIf="rowData.isGraphUser != undefined" [style.color]="rowData.isGraphUser==true ? 'black' : 'red' ">
            {{rowData.userName}}
          </div>
        </td>

        <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
            {{rowData.lastSiteLoadDate | date : 'medium'}}
        </td>

        <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
            {{rowData.createdDate | date : 'medium'}}
        </td>

        <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
          <div class="css-tooltip" style="color: black; cursor: pointer; font-size: 14px;" [attr.tooltip-data]="rowData.groupList"><i class="fas fa-user-friends "></i>&nbsp;&nbsp;&nbsp;({{ rowData.groupListCount }})</div>
        </td>

        <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px; vertical-align: middle;" class="text-center">
          <div *ngIf="!userIsAdmin" (click)="openUserDetails(rowData)" aria-hidden="true" class="far fa-eye" style="color:#1c4966; cursor: pointer; font-size: 14px;"></div>
          <div *ngIf="userIsAdmin" (click)="openUserDetails(rowData)" aria-hidden="true" class="fas fa-pencil-alt" style="color:#64a70b; cursor: pointer; font-size: 14px;"></div>
        </td>

        <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px; vertical-align: middle;" class="text-center">
          <div *ngIf="userIsAdmin" class="far fa-trash-alt"
              style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="onDeleteConfirm(rowData) ">
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template let-columns pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length">
          No records found
        </td>
      </tr>
    </ng-template>
    <ng-template let-rowData pTemplate="caption">
      <div style="text-align: left; margin-top: 10px; margin-bottom: 10px;">
        <label style="font-size: large; vertical-align: middle; color:black; padding-right: 20px; font-weight: 500;">USERS</label>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input (input)="userTable.filterGlobal($event.target.value, 'contains')" pInputText placeholder="Search" size="30" style="width:auto; height: 30px" type="text">
        <label style="margin-left: 20px;">Color Key:  Black (active), Red (not in AD), Purple (unverified)</label>
      </div>
    </ng-template>
    <ng-template let-rowData pTemplate="summary">
      <div class="text-right">
        <!-- <button type="button" class="btn btn-primary" (click)="addEvent(advancedtemplate)">Add</button> -->
      </div>
    </ng-template>
  </p-table>


